import { CheckoutContextType } from "../../utils/checkout";
import {
  PaymentControllerContext,
  usePaymentController,
} from "../../utils/payment-controller";

export interface PaymentControllerProps {
  children?: React.ReactNode;
  checkoutController: CheckoutContextType;
}

export const PaymentController = ({
  children,
  checkoutController,
}: PaymentControllerProps) => {
  const { sale, cashManagedPaymentMethod, roundingPaymentMethod } =
    checkoutController;
  const paymentController = usePaymentController({
    sale,
    roundingPaymentMethod,
    changePaymentMethod: cashManagedPaymentMethod,
    defaultTenderedAmount: "0",
  });

  return (
    <PaymentControllerContext.Provider value={paymentController}>
      {children}
    </PaymentControllerContext.Provider>
  );
};
